import React from 'react';
import {Grid} from 'semantic-ui-react';
import {ChatedHeader} from '../components/chated-header';

import './index.css';

function BasicLayout({containerClass, narrow, center, children}) {
	if (narrow) {
		containerClass = `${containerClass} narrow`;
	}

	if (center) {
		containerClass = `${containerClass} center`;
	}

	return (
		<div>
			<Grid centered>
				{/* <Grid.Row>
					<Grid.Column>
						<ChatedHeader />
					</Grid.Column>
				</Grid.Row> */}

				<Grid.Row>
					<Grid.Column>
						<div className={containerClass}>
							{children}
						</div>
					</Grid.Column>
				</Grid.Row>
			</Grid>
		</div>
	);
}

export default BasicLayout;



// WEBPACK FOOTER //
// ./src/layouts/basic-layout.jsx